// extracted by mini-css-extract-plugin
export default {"root":"InvoiceDownloadButton_root__eAJh2","loading":"InvoiceDownloadButton_loading__WaoZ6"};